import { isCommercePreview } from "@/shared/config/commerce"

export const DEV_AUTH_DOMAIN = "dev.reviewed.co.kr"

/** The shared Dev login and commerce preview must rotate cookies in the same scope. */
export const getAuthCookieDomain = (apiBaseUrl = process.env.API_URL ?? process.env.NEXT_PUBLIC_API_URL) => {
  if (isCommercePreview()) return DEV_AUTH_DOMAIN
  for (const value of [apiBaseUrl, process.env.BASE_URL, process.env.NEXT_PUBLIC_BASE_URL]) {
    try {
      const hostname = new URL(value || "").hostname
      if (hostname === DEV_AUTH_DOMAIN || hostname.endsWith(`.${DEV_AUTH_DOMAIN}`)) return DEV_AUTH_DOMAIN
    } catch {
      // Another trusted deployment URL may still identify Dev with an internal API URL.
    }
  }
  return "reviewed.co.kr"
}

export const AUTH_COOKIE_NAMES = ["accessToken", "refreshToken", "loggedIn", "userInfo"] as const

/** Dev never consumes the legacy/production cookie names, even after sign-out. */
export const authCookieName = (name: string) =>
  getAuthCookieDomain() === DEV_AUTH_DOMAIN && AUTH_COOKIE_NAMES.some((value) => value === name)
    ? `reviewedDev_${name}`
    : name
